import { Link } from "@tvg/fuse/link";
import classNames from "classnames";
import React from "react";
import styles from "./MenuDepartmentLink.module.css";

export interface MenuDepartmentLinkProps {
  href: string;
  children: React.ReactNode;
  className?: string;
  dataTestId?: string;
  onClick?: (
    event: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>,
  ) => void;
  onKeyDown?: (event: React.KeyboardEvent) => void;
  role?: string;
}

const MenuDepartmentLink: React.FC<MenuDepartmentLinkProps> = ({
  href,
  children,
  className,
  dataTestId,
  onClick,
  onKeyDown,
  role,
}) => (
  <>
    <Link
      className={classNames(
        styles.menuDepartmentLink,
        "slide-out-menu__department-link",
        className,
      )}
      dataTestId={dataTestId}
      href={href}
      chevron
      iconRight
      fullWidth
      onClick={onClick}
      onKeyDown={onKeyDown}
      role={role}
      size="large"
      underline={false}
    >
      {children}
    </Link>
  </>
);

export default MenuDepartmentLink;
